import { Link } from "react-router-dom";
import { useState } from "react";
import Clogo from "../../Navbar/image/logo2.svg"
import FuesResponsiveDropdown from "./FuesResponsiveDropdown"; // adjust path
import FooterAppDownloadModal from "./FooterAppDownloadModal";
import BottomFooterModal from "./BottomFooterModal";

export default function FooterSection() {
  // Local state inside footer
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="fues-footer-sec-wrapper">
      {/* First Line */}
      <div className="fues-footer-sec-line-f-line">
        <div className="fues-footer-sec-line-f-text"></div>
        <div className="fues-footer-sec-line-f-text"></div>
      </div>

      {/* Footer Links */}
      <div className="fues-footer-sec-line-f-links">
        <div className="fues-footer-sec-line-f-text-content">
          <FuesResponsiveDropdown
            label="Collections"
            items={[
              { label: "Packages", href: "/party-packages" },
              { label: "Venues", href: "/venues" },
              { label: "Events", href: "/events" },
              { label: "Artists", href: "/artists" },
            ]}
          />
        </div>

        <Link className="f-link-a" to="/custom-package-services">
          <div className="fues-footer-sec-line-f-text-content">Services</div>
        </Link>

        <div className="fues-footer-sec-line-f-text-content">
          <FuesResponsiveDropdown
            label="Partner with Us"
            items={[
              { label: "As an Artist", href: "/partner-as-an-artist" },
              { label: "As a Business", href: "/partner-with-us" },
            ]}
          />
        </div>

        <div className="fues-footer-sec-line-f-text-content">
          <FuesResponsiveDropdown
            label="Agreements"
            items={[
              { label: "Club Agreement", href: "/club-agreement" },
              { label: "Artist Agreement", href: "/artist-agreement" },
            ]}
          />
        </div>

        <div className="fues-footer-sec-line-f-text-content">
          <FuesResponsiveDropdown
            label="Policy & Terms"
            items={[
              { label: "Refund Policy", href: "/refund-policy" },
              { label: "Privacy Policy", href: "/privacy-policy" },
              { label: "Terms & Conditions", href: "/term-conditions-policy" },
            ]}
          />
        </div>

        <Link className="f-link-a" to="/blogs">
          <div className="fues-footer-sec-line-f-text-content">Blogs</div>
        </Link>

        <Link className="f-link-a" to="/contact-us">
          <div className="fues-footer-sec-line-f-text-content">Contact Us</div>
        </Link>

        <div
          className="fues-footer-sec-line-f-text-content"
          onClick={() => setShowModal(true)}
        >
          Get the App
        </div>

        <Link to="/about-us">
          <div className="fues-footer-sec-line-f-text-content">About Us</div>
        </Link>

        <div
          className="fues-footer-sec-line-f-text-content"
          onClick={() => setIsModalOpen(true)}
        >
          More
        </div>
      </div>

      {/* Footer Logo + Copywrite */}
      <div className="fues-footer-sec-line-f-logo-copywrite">
        <div className="fues-footer-sec-line-f-logo">
          <img src={Clogo} alt="Book best party venues" />
        </div>
        <p>AMIRAG HOSPITALITY PVT. LTD © 2025</p>
      </div>

      {/* Local Modals
      {showModal && (
        <div className="footer-modal">
          <div className="footer-modal-content">
            <h2>Download the App</h2>
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="footer-modal">
          <div className="footer-modal-content">
            <h2>More Options</h2>
            <button onClick={() => setIsModalOpen(false)}>Close</button>
          </div>
        </div>
      )} */}

      <FooterAppDownloadModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <BottomFooterModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}
